"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputHeaderView = exports.Asterisk = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _layout = require("../../layout");

var _text = require("../../text");

var _utils = require("../../utils");

var _core = require("@emotion/core");

var AsteriskBase = (0, _context.styledWithTheme)(_text.Text.withComponent('span', {
  target: "e1km6g290"
}))(function (_ref) {
  var selectors = _ref.theme.selectors,
      color = _ref.color;
  return {
    color: selectors.color(color),
    marginLeft: (0, _utils.px)(selectors.space(_utils.LABEL_ASTERISK_SPACING))
  };
});

var Asterisk = function Asterisk(_ref2) {
  var color = _ref2.color;
  return (0, _core.jsx)(AsteriskBase, {
    "aria-hidden": "true",
    color: color
  }, "*");
};

exports.Asterisk = Asterisk;
var InputHeaderView = (0, _context.styledWithTheme)(_layout.View)({
  label: {
    marginInline: "0 ".concat((0, _utils.px)(_utils.DEFAULT_SPACE_BETWEEN_ICON)),
    '& > *': {
      display: 'inline',
      verticalAlign: 'middle'
    }
  }
});
exports.InputHeaderView = InputHeaderView;